import { useState, useEffect, useRef  } from "react";
// Utils
import { handleClearCache } from "../utils";

// CogMenu component is for displaying a cog icon that opens a dropdown menu on NavBar
// The dropdown menu contains a button to clear the cache
const CogMenu = () => {
  const [open, setOpen] = useState(false);

  
  const menuRef = useRef(null);

  // Close dropdown when clicking outside the menu or anywhere on screen
  useEffect(() => {
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  // Handle clearing cache data with confirmation
  const handleClearCacheData = () => {
    if(window.confirm("Are you sure you want to clear the cache? This action cannot be undone.")) {
      handleClearCache();
    }
    setOpen(false);
  };

  return (
    <div
      ref={menuRef}
      className="cog-menu"
      aria-hidden="true"    
      style={{
        display: "inline-block",
      }}
    >
      {/* Cog icon */}
      <button
        onClick={() => setOpen(!open)}
        className="cog-button"
        aria-label="Settings"
      >
        <i class="fa fa-cog" aria-hidden="true"></i>
      </button>

      {/* Dropdown menu */}
      {open && (
        <div
          className="clear-cache-button-wrapper"
        >
          <button
            onClick={handleClearCacheData}
            className="clear-cache-button"
            aria-label="Clear cache"
          >
            🧹 Clear cache
          </button>
        </div>
      )}
    </div>
  );
};

export default CogMenu;